import {DspData} from './AdminDashboardByDsp';
import ReactEcharts from 'echarts-for-react';

interface Props {
    data: DspData[],
    style: {}
}

const PieChartByDsp = (props: Props) => {

    const data = props.data.reduce(function(result: any[], pData) {
        if (pData.name) {
            result.push({value: pData.spendings, name: pData.name});
        }
        return result;
    }, []);

    const labelData = props.data.reduce(function(result: any[], pData) {
        if (pData.name) {
            result.push(pData.name);
        }
        return result;
    }, []);

    const option = {
        title: {
            text: 'Spendings',
            subtext: 'by Dsp',
            left: 'left'
        },
        tooltip: {
            trigger: 'item'
        },
        legend: {
            type: 'scroll',
            orient: 'vertical',
            right: 10,
            top: 20,
            bottom: 20,
            data: labelData
        },
        series: [
            {
                type: 'pie',
                radius: '50%',
                center: ['40%', '50%'],
                label: {
                    formatter: '{b}\n{c}\n({d}%)',
                    edgeDistance: 10
                },
                data: data,
            }
        ]
    }

    return <ReactEcharts style={props.style} option={option}/>
}

export default PieChartByDsp
